export default __webpack_public_path__ + "static/media/baptiste-notover.0d22d8cd.mp3";